export default "__VITE_ASSET__Be_aIhik__"